module.exports = __webpack_public_path__ + "img/avatar.dee46f6f.png";